<template>
  <div>

    <div class="contenedor-input">
      <label for="">Titulo*</label>
      <input :style="styles.input_black" type="text" v-model="data.titulo" v-validate="'required'" name="titulo">
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('titulo') }}</span>
    </div>
    <!-- TIPO OBSERVACION -->
    <div class="contenedor-input -select">
      <label for="">Tipo*</label>
      <select name="idTipoObservacion" v-model="data.idTipoObservacion" v-validate="'required'"
        style="border-bottom: 1px solid rgb(155, 155, 155)">
        <option value=null>-Selecciona un tipo-</option>
        <option selected="selected" value="1">General</option>
        <option value="2">Incidencia</option>
        <option value="3">Otros</option>
      </select>
      <span class='error' v-if="clicked">{{ errors.first('idTipoObservacion') }}</span>
    </div>
    <div class="contenedor-input">
      <label for="">Observación*</label>
      <textarea :style="styles.input_black" type="text" v-model="data.texto" name="texto"
        v-validate="'required'"></textarea>
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('texto') }}</span>
    </div>
    <button v-if="data.urlArchivo && data.idFichero" class="btnRemove" @click="data.idFichero = null ,data.urlArchivo = null">
      <i class="fa fa-trash-o" aria-hidden="true"></i>
      Borrar adjunto
    </button>

    <div class="contenedor-input mb-0">

      <div class="dropzone row-start">

        <div class="text row-start">
          <span class="upload-icon-wrapper">
            <upload-icon v-if="!!!data.fichero.ficheroB64" class="tag-icon"></upload-icon>
            <success-icon v-else></success-icon>
          </span>
          <p v-if="!!!data.fichero.ficheroB64" :style="styles.colorMediumBlack">Arrasta tu archivo o haz click
            para modificar o añadir (Imagen o PDF)</p>
          <p v-else :style="styles.colorMediumBlack">{{ nombreArchivo }}</p>
        </div>

        <input type="file" id="file" name="file" ref="file" @change="handleFileUpload($event)"
          v-validate="`size:20000000|mimes:${formatosPermitidos}`" :class="[{ 'has-error': errors.has('file') }]" />

        <span class='error'>{{ errors.first('file') }}</span>

      </div>

    </div>

    <div class="contenedor-botones row-start">
      <a class="btn -xs" :style="styles.solidPrimary" @click="validate" :loading="loading">Guardar</a>
      <a class="btn -skull -xs" :style="styles.skull_primary" @click="$emit('cancel')">Cancelar</a>
    </div>

  </div>

</template>


<script>

import {
  mapGetters,
  mapActions
} from 'vuex';
import uploadicon from '@/components/parts/icons/upload';
import successicon from '@/components/parts/icons/success';
import arrowlink from '@/components/parts/icons/arrow-link';

export default {
  name: 'nueva-observacion',
  props: ['dataObservacion'],
  components: {
    'upload-icon': uploadicon,
    'success-icon': successicon,
    'arrow-link': arrowlink,
  },
  mounted() {
    if (this.$route.params.status) {
      this.data.idItem = this.$route.params.status;
    }

    if (this.$route.params.id) {
      this.data.idItem = this.$route.params.id;
    }
    if (this.dataObservacion) {
      this.data = {
        "texto": this.dataObservacion.texto,
        "titulo": this.dataObservacion.titulo,
        "idTipoObservacion": this.dataObservacion.idTipoObservacion,
        "fichero": {
          "ficheroB64": "",
          "extension_adjunto": ""
        },
        "idItem": this.dataObservacion.idItem,
        "editar": true,
        "idFichero": this.dataObservacion.idFichero,
        "idObservacion": this.dataObservacion.idObservacion,
        "urlArchivo": this.dataObservacion.urlArchivo
      }
    }
  },
  data: () => ({
    data: {
      "texto": "",
      "titulo": "",
      "idTipoObservacion": null,
      "fichero": {
        "ficheroB64": "",
        "extension_adjunto": ""
      },
      "idItem": '',
      "idFichero": null,
      "idObservacion": null,
      "urlArchivo": null
    },
    loading: false,
    formatosPermitidos: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/msword', 'image/*'],
    clicked: false
  }),
  methods: {
    ...mapActions(['anadirObservacion', 'editarObservacion']),
    handleFileUpload(event) {
      this.$validator.validate('file')
        .then(itsOk => {
          if (itsOk) {
            let file = event.target.files[0];
            this.nombreArchivo = file.name;
            this.data.fichero.extension_adjunto = file.type.split("/")[1];
            this.data.idFichero = null
            this.getBase64(file).then(data => {
              this.data.fichero.ficheroB64 = data;
            });
          }

        });
    },
    getBase64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    validate() {
      this.clicked = true;
      this.$validator.validateAll().then(itsOk => {
        if (itsOk) {
          this.loading = true;
          if (this.data.editar) {
            this.editarObservacion(this.data).then(r => {
              if (r) {
                this.$emit('refresh');
              }
              this.loading = false;
            })
            this.$emit('refresh');
          }
          else {
            this.anadirObservacion(this.data).then(r => {
              if (r) {
                this.$emit('refresh');
              }
              this.loading = false;
            })
          }

        }
      });
    }
  },
  computed: {
    ...mapGetters({
      styles: 'getStyles',
      brand: 'getBrand'
    }),
  },
}
</script>

<style lang="scss" scoped>
.contenedor-botones {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;

  .btn {
    text-decoration: none;
    margin-right: 8px;
  }
}


.dropzone {
  width: 100%;
  min-height: 50px;
  background: #f2f2f2;
  padding: 20px;
  position: relative;
}

.dropzone svg {
  width: 30px;
  height: 30px;
  filter: grayscale(1);
  opacity: .5
}

.dropzone input {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.dropzone .text {
  width: 100%;
}

.dropzone p {
  text-align: center;
  font-size: 14px;
  color: #333;
  margin-left: 20px;
  margin-bottom: 0;
  width: auto;
}

.dropzone span.error {
  bottom: -24px;
}

</style>


// WEBPACK FOOTER //
// src/components/parts/nueva-observacion.vue